import { getQueryDefinition } from '@intelligence/services/common';

/**
 * 获取cond配置的参数信息
 */
export interface ICondConfigQueryParams {
  /**
   * 要查询数据的配置的数据表的键，一般后端提供
   */
  target?: string;
  /**
   * 查询的其他参数
   */
  params: {
    /**
     * cond配置的键，可以是abc_def*这种格式，支持模糊查询
     */
    key?: string;
    /**
     * 其他查询参数
     */
    [key: string]: any;
  };
}

/**
 * 获取game_config表的配置，系统通用配置
 * @param params - 参数对象
 */
export const fetchCondConfigs = (params: IRecord<ICondConfigQueryParams>): IBaseResponse<IRecord> => {
  return getQueryDefinition(params);
};
